import {Action} from '@ngrx/store';
import {QueryParams} from '../interfaces/queryparams.interface';

export const SET_QUERYPARAM = '[Query Param] set query params';
export const DISMIS_QUERYPARAM = '[Query Param] dismis query params';

export class SetQueryParams implements Action {
  readonly type = SET_QUERYPARAM;
  constructor(public payload: QueryParams) {}
}
export class DismisQueryParams implements Action {
  readonly type = DISMIS_QUERYPARAM;
  constructor(public payload: QueryParams) {}
}

export type Actions = SetQueryParams | DismisQueryParams;
